module.exports = __webpack_public_path__ + "img/03.2559b21a.jpg";